export default "__VITE_ASSET__DZi7m0N7__"